import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
// import { Reveal } from "react-awesome-reveal";
// import { keyframes } from "@emotion/react";
// import { Icon } from "@iconify/react";
// import { isDesktop } from "react-device-detect";

// import { Modal } from "react-responsive-modal";
// import SideBar from "../../components/Sidebar/Sidebar";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import PersonalFinance from "./PersonalFinance";

import { TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'

class MobileFinancialReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageShow: "personal_finance",
            filterShow: '',
        };
    }

    showDateHandler = () => {
        this.setState({
            filterShow: 'date'
        })
    }


    offDateHandler = () => {
        this.setState({
            filterShow: ''
        })
    }

    showTypeHandler = () => {
        this.setState({
            filterShow: 'type'
        })
    }

    showProviderHandler = () => {
        this.setState({
            filterShow: 'provider'
        })
    }


    render() {
        const { t } = this.props;
        return (
            <>
                <section className="pf-m-dashboard">
                    {/* <div className="filters-m-col show">
                    <MobileSubHeader
                        className="bg-white"
                        returnPage="/"
                        header="Delegate Deposit"
                        modalHeader={true}
                        modalHandler={this.props.toggleModal}
                    />
                    </div> */}
                    <TabContainer defaultActiveKey="personal_finance">
                        <div className={`filters-m-col ${this.state.filterShow ? 'show' : ''}`} >
                            <MobileSubHeader
                                className="bg-white"
                                returnPage="/"
                                header={t('financial-report.financial-report')}
                                subPage={true}
                                modalHandler={this.props.toggleModal}
                            />
                            <div className="delegate-deposit-wrap ">
                                <Nav className='mobile delegate-deposit-nav' variant="pills">
                                    <NavItem>
                                        <NavLink eventKey="personal_finance" id="personal_finance" onClick={(event) => this.props.changeTabHandler(event)}>{t('financial-report.personal-finance')}</NavLink>
                                    </NavItem>
                                    {/* <NavItem>
                                        <NavLink eventKey="escrow_wallet" id="escrow_wallet" onClick={(event) => this.props.changeTabHandler(event)}>Delegate Wallet</NavLink>
                                    </NavItem> */}
                                </Nav>
                            </div>
                        </div>
                        <TabContent className='tab-content-container'>
                            <TabPane eventKey="personal_finance">
                                <PersonalFinance
                                    {...this.state}
                                    {...this.props}
                                    showDateHandler={this.showDateHandler}
                                    offDateHandler={this.offDateHandler}
                                    showProviderHandler={this.showProviderHandler}
                                    showTypeHandler={this.showTypeHandler}
                                />
                            </TabPane>
                            <TabPane eventKey="escrow_wallet">
                                {/* <EscrowWallet
                                    {...this.state}
                                    {...this.props}
                                    showDateHandler={this.showDateHandler}
                                    offDateHandler={this.offDateHandler}
                                    showProviderHandler={this.showProviderHandler}
                                    showTypeHandler={this.showTypeHandler}
                                /> */}
                            </TabPane>
                        </TabContent>
                    </TabContainer>

                </section>
            </>
        )
    }
}

export default withNamespaces("translation")(MobileFinancialReport);